import React, { useState, useEffect, useContext } from 'react';
import { ReactSession } from "react-client-session";
import { Buffer } from 'buffer';
import { ContextGloball } from './Context/ContextGlobal';
import kingdomImg from '../assets/logo_kingdom_256px.png';
function Header({ login }) {
    const [session, setIdsession] = useState(0);
    const { titulo, setShowMenu, setVentana, setTitulo } = useContext(ContextGloball);
    const mostrarUserLogin = () => {
        if (ReactSession.get("idSession") !== undefined) {
            var imagen = Buffer.from(ReactSession.get("foto").data);
            imagen = imagen.toString('base64');
            var src = 'data:image/jpg;base64,' + imagen;
            return (
                <div className="navbar-brand card flex-row bg-dark m-0 p-0 " >
                    <div className="dropdown dropstart">
                        <a className="btn btn-sm dropdown-toggle" role="button" id="MenuOptiones" data-bs-toggle="dropdown" aria-expanded="false">
                            <img src={src} width="42" height="42" className=" my-auto rounded-circle card-img-left border border-white border-2 imgUser" />
                        </a>
                        <ul className="dropdown-menu bg-light bg-gradient" aria-labelledby="MenuOptiones">
                            <li><a className="dropdown-item btn btn-sm fw-bold" onClick={()=>cambiarVentana('7','Cambiar Credenciales')}>Cambiar Usuario/Contraseña</a></li>
                            <li><a className="dropdown-item btn btn-sm fw-bold" onClick={()=>cambiarVentana('8','Ver Perfil')}>Ver Perfil</a></li>
                        </ul>
                    </div>
                    <div className='ps-2 my-auto d-none d-sm-inline'>
                        <div className="nombreHeader lh-sm">{ReactSession.get("nombre")}<br></br><span className='cargoHeader text-decoration-underline'>{ReactSession.get("cargo")}</span></div>
                    </div>
                    <a className='btn btn-sm btn-transparent fs-4 my-auto text-light btnMenu'
                        onClick={() => setShowMenu(true)}>
                        <i className="fa-solid fa-bars"></i>
                    </a>
                </div>);
        }
    }
    function cambiarVentana(tipo,dato){
        setVentana(tipo);
        setTitulo(dato);
    }
    useEffect(() => {
        if (ReactSession.get("idSession") !== undefined) {
            setIdsession(ReactSession.get("idSession"));
        } else {
            setIdsession(0);
        }
    }, [login]);
    return (
        <div className="navbar navbar-dark bg-dark m-0 p-0">
            <div className="container-fluid">
                <div className="navbar-brand card flex-row bg-dark m-0 p-0 py-1" >
                    <img src={kingdomImg} width="50" className="d-inline-block align-text-top card-img-left my-auto" />
                    <div className='ps-2 my-auto d-none d-sm-inline'>
                        <div className="cargoHeader lh-sm">Chicken's<br></br>Kingdom</div>
                    </div>
                </div>
                {titulo !== '' &&
                    <div className='text-light fw-bold fs-6 text-uppercase'>{titulo}</div>}
                {mostrarUserLogin()}
            </div>
        </div>
    );
}

export default Header;